import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { NgxAimAdminEditTaxAuthorityComponent } from './edit-tax-authority/ngx-aim-admin-edit-tax-authority.component';
import { NgxAimAdminPrimengModule } from '../ngx-aim-admin.primeng.module';
import { AppLazyLoadEvent } from '../../../models';
import { HttpErrorService } from '../../../services';
import { MatchModesPrime } from '../../../enums';
import { NgxAimAdminTaxAuthorityService } from './ngx-aim-admin-tax-authority.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'ngx-aim-admin-tax-authority',
  standalone: true,
  imports: [FormsModule, NgxAimAdminPrimengModule, AsyncPipe, NgClass],
  templateUrl: './ngx-aim-admin-tax-authority.component.html',
  styleUrls: ['./ngx-aim-admin-tax-authority.component.scss', '../admin.scss'],
  providers: [DialogService],
})
export class NgxAimAdminTaxAuthorityComponent {
  @ViewChild('dt') table: Table | undefined;
  data$ = this.entityService.data$;
  isLoading$ = this.entityService.isLoading$;
  dataCount$ = this.entityService.dataCount$;
  lastLazyLoadEvent: AppLazyLoadEvent = {
    globalFilterFields: [],
    filters: {}
  };
  selectedOptions: string[] = [];
  isSyncing = false;

  constructor(
    private entityService: NgxAimAdminTaxAuthorityService,
    private dialogService: DialogService,
    private httpErrorService: HttpErrorService,
    private messageService: MessageService
  ) {}

  onLazyLoad($event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = $event;
    const lazyLoadEvent: AppLazyLoadEvent = Object.assign({
      withDeleted: this.selectedOptions.includes('withDeleted'),
      globalFilterFields: this.table?.globalFilterFields || [],
    }, $event);

    this.entityService.onFilterEvent(lazyLoadEvent);
  }

  applyFilterGlobal($event: Event) {
    this.table?.filterGlobal(($event.target as HTMLInputElement).value, MatchModesPrime.CONTAINS);
  }

  onSyncClick() {
    this.isSyncing = true;
    this.entityService.sync().subscribe({
      next: () => this.onSyncSuccess(),
      error: (err) => this.onSyncError(err, 'Could not sync tax authorities'),
    });
  }

  onSyncSuccess() {
    this.isSyncing = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Confirmed',
      detail: `Tax authorities synced`,
      key: 'app-toast',
      life: 5000
    });
    this.onLazyLoad(this.lastLazyLoadEvent);
  }

  onSyncError(err: any, summary: string) {
    this.isSyncing = false;
    this.httpErrorService.onHttpError(err, summary);
  }

  openEntity(entityId?: number) {
    const dialog = this.dialogService.open(NgxAimAdminEditTaxAuthorityComponent, {
      data: entityId,
      header: 'Tax Authority',
      width: '700px',
      contentStyle: { "max-height": "580px", "overflow": "auto" },
      dismissableMask: true
    });
    dialog.onClose.subscribe(() => {
      this.onLazyLoad(this.lastLazyLoadEvent);
    });
  }
}
